// Map glyphs as flat polygon point lists in a unit box (nose up = −y), drawn with Pixi Graphics
// and, for the legend, as inline SVG. Shapes, not only colour, tell things apart (GDD 08 §4).
import type { ShipType } from '@stars-and-ships/api-types';

export const SHIP_GLYPHS: Record<ShipType, number[]> = {
  interceptor: [0, -1, 0.6, 0.8, 0, 0.4, -0.6, 0.8],
  transport: [-0.6, -0.9, 0.6, -0.9, 0.8, 0.9, -0.8, 0.9],
  frigate: [0, -1, 0.6, 0, 0, 1, -0.6, 0],
  cruiser: [0, -1, 0.5, -0.4, 0.5, 0.9, -0.5, 0.9, -0.5, -0.4],
  carrier: [-0.9, -0.4, 0.9, -0.4, 0.9, 0.6, -0.9, 0.6],
  battleship: [0, -1, 0.9, 0.3, 0.5, 0.9, -0.5, 0.9, -0.9, 0.3],
  dreadnought: [0, -1, 0.9, -0.4, 0.9, 0.6, 0, 1, -0.9, 0.6, -0.9, -0.4],
};

/** System type icons; Standard systems have none. */
export const TYPE_ICONS = {
  resource_rich: { points: [0, -1, 1, 0, 0, 1, -1, 0], filled: true },
  strategic: { points: [0, -1, 1, 0.8, -1, 0.8], filled: true },
  barren: { points: [-0.8, -0.8, 0.8, -0.8, 0.8, 0.8, -0.8, 0.8], filled: false },
} as const satisfies Record<string, { points: readonly number[]; filled: boolean }>;

/** House outline around the home system. */
export const HOME_MARKER = [0, -1.2, 1, -0.3, 1, 1, -1, 1, -1, -0.3];

/** Chevron of a fleet in flight. */
export const FLEET_MARKER = [0, -1, 0.8, 0.8, 0, 0.35, -0.8, 0.8];

/** Scales a glyph by `size`, rotates it by `angle` and moves it to (cx, cy). */
export function placeGlyph(
  points: readonly number[],
  cx: number,
  cy: number,
  size: number,
  angle = 0
): number[] {
  const cos = Math.cos(angle);
  const sin = Math.sin(angle);
  const out: number[] = [];
  for (let i = 0; i < points.length; i += 2) {
    const x = (points[i] as number) * size;
    const y = (points[i + 1] as number) * size;
    out.push(cx + x * cos - y * sin, cy + x * sin + y * cos);
  }
  return out;
}
